import { AppConfig } from '@tcs/client-portal/types/AppConfig';
import { getConfigFromApi } from '@tcs/common/utils/getConfigFromApi';

const config = {} as AppConfig;

export const loadConfig = async (): Promise<AppConfig> => {
  const configResult = await getConfigFromApi<AppConfig>();

  Object.assign(config, {
    ...configResult,
    COLLECT_SURVEY: Math.random() < configResult.SURVEY_THRESHOLD,
  });
  Object.freeze(config);

  return config;
};

export const getConfig = (): AppConfig => config;
